import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/home-webapp/src/components/pages/ethical-report/_components/EthicalForm.tsx");
